<template>
  <div class="icon-info">
    <div class="icon-data home-border">
      <div
        v-for="(item, index) in defaultList"
        :key="index"
        class="icon-list"
        @click="gotoTemp(item)"
      >
        <div class="icon-image" :style="item.style"></div>
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Home } from "@/config/axios/new_api";
export default {
  data() {
    return {
      defaultList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
        let res = await Home.getData({ type: 3})
        if (Array.isArray(res.data) && res.data.length) {
          this.defaultList = res.data.map((item) => {
            item.name_edit_status = false;
            item.style = `background-image: url(${item.url})`;
            return item;
          });
        }
    },
    gotoTemp(item) {
      if (item.path_type === 1) {
        this.$router.push({
          name: "TemplateList",
          query: {
            id: item.directories_id,
            name: item.name,
            type: "icon",
          },
        });
      } else {
        this.goDesignworkbench(item, item.template_id);
      }
    },
  },
};
</script>

<style lang="scss">
.icon-info {
  @include wh(100%, 100px);
  .icon-data {
    @include wh(100%, 100px);
  }
  .icon-list {
    @include wh(184px, 80px);
    float: left;
    margin-right: 19px;
    line-height: 36px;
    padding: 22px 20px;
    font-size: 16px;
    color: #3b3946;
    cursor: pointer;
    border-radius: 8px;
    position: relative;
    z-index: 10;
    &:hover {
      background: $hoverColor;
    }
    &:last-child {
      margin-right: 0;
    }
    .icon-image {
      @include wh(36px, 36px);
      border-radius: 8px;
      float: left;
      margin-right: 12px;
      background-size: 100% 100%;
    }
  }
}
</style>
